import { Outlet } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";

export default function DashboardLayout() {
  return (
    <div className="min-h-screen bg-gray-100">
      <PageHeader
        title="Dashboard"
        description="Métricas del negocio, sucursales y conductores"
      />
      <Outlet />
    </div>
  );
}
